import type { LocationOption } from "./types-explorer";

export const LOCATIONS: LocationOption[] = [
  { id: "loc_mk", label: "Magic Kingdom — entrance", group: "Parks", lat: 28.4177, lng: -81.5812 },
  { id: "loc_ep", label: "EPCOT — entrance", group: "Parks", lat: 28.3747, lng: -81.5494 },
  {
    id: "loc_hs",
    label: "Hollywood Studios — entrance",
    group: "Parks",
    lat: 28.3575,
    lng: -81.5586,
  },
  { id: "loc_ak", label: "Animal Kingdom — entrance", group: "Parks", lat: 28.3553, lng: -81.5901 },
  { id: "loc_ds", label: "Disney Springs — center", group: "Areas", lat: 28.3705, lng: -81.519 },
  { id: "loc_bb", label: "Blizzard Beach", group: "Areas", lat: 28.352, lng: -81.574 },
  { id: "loc_tl", label: "Typhoon Lagoon", group: "Areas", lat: 28.366, lng: -81.529 },
  {
    id: "loc_poly",
    label: "Polynesian Village Resort",
    group: "Resorts",
    lat: 28.4056,
    lng: -81.5854,
  },
  { id: "loc_gf", label: "Grand Floridian Resort", group: "Resorts", lat: 28.4109, lng: -81.5874 },
  { id: "loc_cont", label: "Contemporary Resort", group: "Resorts", lat: 28.415, lng: -81.5745 },
  { id: "loc_bw", label: "BoardWalk Inn", group: "Resorts", lat: 28.3668, lng: -81.5557 },
  { id: "loc_yc", label: "Yacht & Beach Club", group: "Resorts", lat: 28.3712, lng: -81.5573 },
  { id: "loc_ftw", label: "Fort Wilderness", group: "Resorts", lat: 28.4059, lng: -81.5574 },
  { id: "loc_cor", label: "Coronado Springs", group: "Resorts", lat: 28.3625, lng: -81.5732 },
  { id: "loc_akl", label: "Animal Kingdom Lodge", group: "Resorts", lat: 28.3541, lng: -81.6054 },
  { id: "loc_okw", label: "Old Key West", group: "Resorts", lat: 28.375, lng: -81.5335 },
  { id: "loc_ssr", label: "Saratoga Springs", group: "Resorts", lat: 28.379, lng: -81.5198 },
  { id: "loc_4s", label: "Four Seasons", group: "Resorts", lat: 28.4027, lng: -81.5462 },
  { id: "loc_swan", label: "Swan & Dolphin", group: "Resorts", lat: 28.3669, lng: -81.5601 },
];

export function locationById(id: string): LocationOption | undefined {
  return LOCATIONS.find((l) => l.id === id);
}

export function activeOrigin(
  originId: string,
  geoCoords: { lat: number; lng: number } | null
): { lat: number; lng: number } {
  if (originId === "geo" && geoCoords) return geoCoords;
  const lookupId = originId === "geo" ? "loc_mk" : originId;
  const loc = locationById(lookupId) ?? locationById("loc_mk");
  if (!loc) throw new Error("loc_mk missing from LOCATIONS — locations.ts is broken");
  return { lat: loc.lat, lng: loc.lng };
}
